import React, { useEffect, useRef, useState } from "react";

export default function WorkflowKebabMenu({ actions = [] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div style={{ position: "relative" }} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        style={{
          width: 34,
          height: 34,
          borderRadius: 8,
          border: "1px solid #dbe3ef",
          background: "#fff",
          cursor: "pointer",
          fontSize: 18,
          fontWeight: 700,
        }}
      >
        ⋮
      </button>
      {open && (
        <div
          style={{
            position: "absolute",
            right: 0,
            top: 38,
            minWidth: 180,
            border: "1px solid #dbe3ef",
            borderRadius: 10,
            background: "#fff",
            boxShadow: "0 14px 32px rgba(15,23,42,0.14)",
            zIndex: 20,
            overflow: "hidden",
          }}
        >
          {actions
            .filter((action) => !action.hidden)
            .map((action) => (
              <button
                key={action.label}
                type="button"
                disabled={action.disabled}
                onClick={() => {
                  setOpen(false);
                  action.onClick?.();
                }}
                style={{
                  width: "100%",
                  border: "none",
                  borderBottom: "1px solid #edf2f7",
                  background: "#fff",
                  padding: "9px 12px",
                  textAlign: "left",
                  fontSize: 13,
                  cursor: action.disabled ? "not-allowed" : "pointer",
                  color: action.destructive ? "#b91c1c" : "#1f2937",
                  opacity: action.disabled ? 0.5 : 1,
                }}
              >
                {action.label}
              </button>
            ))}
        </div>
      )}
    </div>
  );
}
